import React, { FC } from 'react';

import { LoadingOutlined } from '@ant-design/icons';
import { Avatar, Button, Col, Row } from 'antd';
import { FormattedMessage } from 'react-intl';
import { ChallengeResourceWrapperBlocked } from 'src/components/challenge/ChallengeResourceWrapper';
import { IChallengeDetailsBox } from 'src/shared/models';

export const ChallengeDetailsBox: FC<IChallengeDetailsBox> = ({
  allowRetry,
  detailTitle = '',
  completed,
  date,
  description,
  disabled = false,
  expired,
  handleShowSurvey,
  image,
  isSurvey = false,
  isCampaignComponent = false,
  loading = false,
  points,
  setShowComponent,
  showQuiz,
  title,
}) => {
  let buttonTitle = '';
  let resourceText;

  switch (true) {
    case isSurvey && completed:
      break;
    case isSurvey && !completed && detailTitle !== '':
      resourceText = detailTitle;
      break;
    case isSurvey && !completed && detailTitle === '':
      buttonTitle = 'page.challenge.survey.start';
      break;
    case completed:
      buttonTitle = 'page.challenge.quiz.completed';
      break;
    default:
      buttonTitle = 'page.challenge.quiz.start';
      break;
  }

  let buttonDisabled = disabled || (completed && !allowRetry) || showQuiz;
  if (isSurvey && showQuiz) buttonDisabled = false;

  const renderButton = () => {
    if (!buttonTitle && !resourceText) return;
    return (
      <Button
        className={`btn-ghost btn-ghost--black ${
          buttonDisabled ? 'btn-ghost--black--disabled' : ''
        }`}
        onClick={() => {
          if (!buttonDisabled) setShowComponent && setShowComponent(true);
          if (showQuiz && handleShowSurvey) handleShowSurvey();
        }}
        block
      >
        <Row justify="space-between" align="middle">
          <span>{resourceText ?? <FormattedMessage id={buttonTitle} />}</span>
          <a className={`icon icon--arrow-dropdown-down`} />
        </Row>
      </Button>
    );
  };

  const renderDetailStatus = () => {
    if (isCampaignComponent || !completed) return;
    return (
      <div className="quiz-image-label">
        <FormattedMessage
          id={`page.challenge-card.user-status.${
            isSurvey ? 'survey' : 'quiz'
          }-done`}
        />
      </div>
    );
  };

  const renderDetailDates = (
    <>
      <div className="icon icon--calendar challenge-detail-box-icon" />
      {date}
    </>
  );

  const renderDetailPoints = (
    <>
      <div className="icon icon--puntos challenge-detail-box-icon" />
      <FormattedMessage
        id="page.challenge.win-{points}-points"
        values={{
          points: Number(points).toLocaleString(),
        }}
      />
    </>
  );

  const renderSpecialWarning =
    completed && !isSurvey ? (
      <Row
        className="container-repeat-quiz container-repeat-quiz--small"
        justify="center"
        align="middle"
      >
        <FormattedMessage id="page.challenge.taking-this-quiz-again-will-not-earn-you-more-points" />
      </Row>
    ) : (
      <React.Fragment />
    );

  const renderExpiredWarning =
    expired && isSurvey ? (
      <Row
        className="container-expired-quiz container-repeat-quiz--small"
        justify="center"
        align="middle"
      >
        <FormattedMessage id="page.challenge.survey.expired" />
      </Row>
    ) : (
      <React.Fragment />
    );

  const buildQuizCard = (
    <Col xs={24} md={24} lg={24}>
      <Row className="quiz-card-container" justify="center" align="top">
        <div className="quiz-card-container__image">
          <ChallengeResourceWrapperBlocked />
          <div className="quiz-image-container">
            <Avatar
              className={image ? 'quiz-image' : 'quiz-no-image'}
              shape="square"
              src={image}
            />
            {renderDetailStatus()}
          </div>
        </div>
        <Row className="quiz-data">
          <Row className="quiz-name block--small">{title}</Row>
          <Row className="quiz-description block--small">{description}</Row>
          {date && <Row className=" quiz-date">{renderDetailDates}</Row>}
          <Row className="quiz-points block--small">{renderDetailPoints}</Row>
          {renderSpecialWarning}
          <Row className="quiz-button-start block--small">
            <Col xs={24} className="container-button">
              {expired ? renderExpiredWarning : renderButton()}
            </Col>
          </Row>
        </Row>
      </Row>
    </Col>
  );

  return (
    <div className="quiz-cover">
      <Row justify="center">
        {loading ? (
          <Avatar icon={<LoadingOutlined />} size={64} />
        ) : (
          buildQuizCard
        )}
      </Row>
    </div>
  );
};
